import { RootState } from '@app/store/store';

export const selectIsAuthenticated = (state: RootState) => !!state.auth.accessToken;
export const selectIsAuthBootstrapping = (state: RootState) => state.auth.isBootstrapping;
